import { makePostRequest } from '@/api/fetchCalls'
import {
  CreateCustomerFileAttachment,
  CustomerFileAttachment,
} from '@/types/customer'

const FILE_API_BASE = `${process.env.REACT_APP_API_URL}/files`

export const addCustomerFileAttachment = async (
  data: CreateCustomerFileAttachment
): Promise<CustomerFileAttachment> => {
  const formData = new FormData()
  formData.append('customer', data.customer.toString())
  formData.append('file', data.file)
  return makePostRequest(FILE_API_BASE + `/customer-file-attachments`, {
    body: formData,
  })
}
